import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { from, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from '../../../environments/environment';
import { KeycloakAuthService } from "./keycloak-auth.service";

@Injectable()
export class AuthenticationService {

    constructor(private http: HttpClient, private keycloakAuthService: KeycloakAuthService) {
    }

    login(username: string, password: string) {
        if (this.keycloakAuthService.isEnabled()) {
            return from(this.keycloakAuthService.login());
        }

        let headers: HttpHeaders = new HttpHeaders({
            "Accept": "application/json",
            "Content-Type": "application/json"
        });

        return this.http.post(`${environment.ConfigEndpoints["login"]}jwt`, { username: username, password: password }, { headers: headers })
            .pipe(map((user: any) => {
                // login successful if there's a jwt token in the response
                if (user && user.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }
            }), catchError(this.handleError));
    }

    private handleError(error: any) {
        return throwError(() => (error.error && error.error.message) || error.message || 'Server Error');
    }

    private deleteCookie(value: string) {
        document.cookie = value + "=;-1;path=/";
    }

    logout() {
        if (this.keycloakAuthService.isEnabled()) {
            this.keycloakAuthService.logout(this.buildAppLoginUrl());
            return;
        }

        // remove user from local storage to log user out
        //..

        // If authentication was made with external login (e.g. Google) redirect to logout to clear session
        if ((+localStorage.getItem('external')) === 1) {
            localStorage.clear();
            window.location.href = `${environment.ConfigEndpoints["login"]}logout?app_url=${encodeURIComponent(this.buildAppLoginUrl())}`;
        } else {
            localStorage.clear();
            window.location.href = this.buildAppLoginUrl();
        }
    }

    private buildAppLoginUrl(): string {
        return new URL('login/', document.baseURI).href;
    }
}
